// extracted by mini-css-extract-plugin
module.exports = {"use_time":"useTime_use_time__d05Nc"};